import useBogo from '../menu-handlers-by-kind/useBogo';
import { Offer } from '../../../../services/exports/Interfaces';
import { OfferKindEnum } from '../../../../services/exports/Constants';
import useBogoHalfPrice from '../menu-handlers-by-kind/useBogoHalfPrice';
import useAmountOffByProducts from '../menu-handlers-by-kind/useAmountOffByProducts';
import useFreeItemByMinSpendValue from '../menu-handlers-by-kind/useFreeItemByMinSpendValue';
import useFreeItemByProducts from '../menu-handlers-by-kind/useFreeItemByProducts';
import usePercentageOffByMinSpendValue from '../menu-handlers-by-kind/usePercentageOffByMinSpendValue';
import usePercentageOffByProducts from '../menu-handlers-by-kind/usePercentageOffByProducts';
import { IProductOfferResult } from '../../types';

const useGetMenuOfferHandlerByKind = (): ((offer: Offer) => ReturnType<IProductOfferResult>) => {
  const handlers: Partial<Record<OfferKindEnum, IProductOfferResult>> = {
    [OfferKindEnum.Bogo]: useBogo(),
    [OfferKindEnum.BogoHalfPrice]: useBogoHalfPrice(),
    [OfferKindEnum.AmountOffByProducts]: useAmountOffByProducts(),
    [OfferKindEnum.FreeItemByMinSpendValue]: useFreeItemByMinSpendValue(),
    [OfferKindEnum.FreeItemByProducts]: useFreeItemByProducts(),
    [OfferKindEnum.PercentageOffByMinSpendValue]: usePercentageOffByMinSpendValue(),
    [OfferKindEnum.PercentageOffByProducts]: usePercentageOffByProducts(),
  } as const;

  return (offer) => handlers[offer?.kind] && handlers[offer?.kind](offer);
};

export default useGetMenuOfferHandlerByKind;
